import { Button, Icon } from '@iwoca/orion';
import clsx from 'clsx';
import styles from './NotificationButton.module.css';

type TProps = {
  onClick?: () => void;
  numberUnread?: number;
  isOpen?: boolean;
};

export const NotificationButton = ({
  onClick,
  numberUnread = 0,
  isOpen = false,
}: TProps) => {
  return (
    <Button
      iconOnly
      data-testid="notifications-button"
      variant="tertiary"
      size="small"
      onClick={onClick}
      disabled={!onClick}
      className={styles.notificationButton}
    >
      {numberUnread > 0 && (
        <span
          className={clsx(styles.numberUnread, {
            [styles.overThreshold]: numberUnread > 50,
          })}
        >
          {numberUnread > 50 ? '50+' : numberUnread}
        </span>
      )}

      <Icon
        icon={isOpen ? 'bellFilled' : 'bellOutline'}
        className={styles.bellIcon}
      />
    </Button>
  );
};
